import { InjectionToken } from '@angular/core';

export const PROTECTED_URIS = new InjectionToken<Record<string, string>>('PROTECTED_URIS');
